import { useEffect } from "react";

import { TextField } from "@material-ui/core/";

import { Container, makeStyles } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import { Autocomplete } from "@material-ui/lab";
import { useState } from "react";
import { useHistory } from "react-router-dom";
import { useGlobal } from "../../../contexts/globalContext";
import PackageRepository from "../../../repositories/packageRepository";
import ChoosePackageRooms from "../../ChoosePackageRooms";
import RegisterModal from "../../RegisterModal";
import ThemeButton from "../../ThemeButton";
import * as S from "./styles";

import cleanStorageBeforeSearch from "../../../utils/cleanStorageBeforeSearch";
import { getSessionStorage } from "../../../utils/getSessionStorage";
import { validateAllRooms } from "../../../utils/validator";
const initialState = {
  origin: "",
  destination: "",
  dates: "",
  occupancy: [
    {
      adults: 2,
      children: 0,
      childrenAges: [],
    },
  ],
  qtAdult: 2,
  qtChild: 0,
  qtRooms: 1,
};

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiFormHelperText-root.Mui-error": {
      color: "white",
    },
    opacity: 1,
    "& .MuiInputBase-input": {
      color: `#FFF`,
    },
    "& label.Mui-focused": {
      color: `#FFF`,
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: `#FFF`,
      color: `#FFF`,
    },
    "& .MuiFormLabel-root": {
      color: "#FFF",
      opacity: 0.45,
    },
    "& .MuiSelect-icon": {
      color: "#FFF",
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: `#FFF`,
        color: `#FFF`,
      },
      "&:hover fieldset": {
        borderColor: `#FFF`,
        color: `#FFF`,
        borderWidth: 2,
      },
      "&.Mui-focused fieldset": {
        borderColor: `#FFF`,
        color: `#FFF`,
      },
      "&.Mui-error fieldset": {
        borderColor: "#FFF",
      },
    },
  },
}));

const PackageSearchInputs = () => {
  const { showAlert, user } = useGlobal();
  let history = useHistory();
  const classes = useStyles();

  const [state, setState] = useState(initialState);
  const [options, setOptions] = useState([]);
  const [destinationOptions, setDestinationOptions] = useState([]);
  const [send, setSend] = useState(false);
  const [openModalChild, setOpenModalChild] = useState(false);
  const [dateOptions, setDateOptions] = useState([]);
  const [loadingOrigin, setLoadingOrigin] = useState(false);
  const [loadingDestination, setLoadingDestination] = useState(false);
  const [loadingDate, setLoadingDate] = useState(false);
  const [isOpenRegisterModal, setIsOpenRegisterModal] = useState(false);

  const handleRegisterModal = () => setIsOpenRegisterModal((prev) => !prev);

  const handleAutoComplete = (event, value) => {
    const packageRepository = new PackageRepository();

    if (value.length >= 3) {
      const payload = {
        filter: {
          name: value,
        },
      };

      setLoadingOrigin(true);
      packageRepository.searchAutoComplete(payload).then((res) => {
        setOptions(res?.data || []);
        setLoadingOrigin(false);
      });
    }
  };

  const handleChangeChildsAge = (age) => {
    setState({ ...state, childAge: Object.values(age) });
  };

  const handleSubmit = () => {
    setSend(true);

    const totalPassengers = state.qtAdult + state.qtChild;
    if (totalPassengers > 9) {
      showAlert(
        "warning",
        "Ops! Para grupos acima de 9 pessoas, nosso time de especialistas entra em ação! Entre em contato e descubra opções personalizadas para sua viagem."
      );
      history.push("/plantrip");
      return;
    }

    if (state.occupancy) {
      const apartmentsForValidation = state.occupancy.map((occ) => ({
        adults: occ.adults,
        seniors: 0,
        childs: occ.children,
      }));

      const roomValidation = validateAllRooms(apartmentsForValidation);
      if (!roomValidation.valid) {
        showAlert(
          "error",
          `O quarto ${roomValidation.roomIndex + 1} possui ${
            roomValidation.totalGuests
          } hóspedes. O máximo permitido é de 4 pessoas por quarto.`
        );
        return;
      }
    }

    if (
      state.origin === "" ||
      state.destination === "" ||
      state.dates === "" ||
      state.qtRooms === 0 ||
      (state.qtAdult === 0 && state.qtChild === 0)
    ) {
      showAlert("error", "Por favor, preencha todos os campos");
    } else {
      cleanStorageBeforeSearch();
      sessionStorage.setItem("packageSearch", JSON.stringify(state));
      sessionStorage.setItem("buscaAtual", "Pacote");

      const request = {
        filter: {
          avail: {
            period: {
              start: state.dates.start,
              end: state.dates.end,
            },
            occupancy: state.occupancy,
            origin: state.origin,
            destination: state.destination,
          },
        },
      };

      localStorage.setItem("@packageRequest", JSON.stringify(request));

      if (user?.guest || user?.travelVoucher) {
        return handleRegisterModal();
      }

      history.push("/busca/resumo");
    }
  };

  const mountRooms = (rooms) => {
    const occupancy = rooms.apartments.map((a) => ({
      adults: a.adults,
      children: a.childs,
      childrenAges: a.childsAge,
    }));

    setState({
      ...state,
      qtAdult: rooms.qtAdult,
      qtChild: rooms.qtChild,
      qtRooms: rooms.qtRooms,
      childAge: rooms.childAge,
      occupancy,
    });
    setOpenModalChild(false);
  };

  const handleDestination = (originData = null) => {
    const origin = originData || state.origin;
    if (!origin || !origin.id) return;

    const packageRepository = new PackageRepository();

    const payload = {
      filter: {
        origin: {
          id: origin.id,
          iata: origin.iata,
          type: origin.type,
        },
      },
    };

    setLoadingDestination(true);
    packageRepository.searchOrigins(payload).then((res) => {
      setDestinationOptions(res?.data || []);
      setLoadingDestination(false);
    });
  };

  const handleDates = (destinationData = null) => {
    const destination = destinationData || state.destination;
    const origin = state.origin;
    if (!destination || !destination.iata) return;
    if (!origin || !origin.iata) return;
    const packageRepository = new PackageRepository();

    const payload = {
      filter: {
        destination: {
          iata: destination.iata,
        },
        origin: {
          iata: origin.iata,
        },
      },
    };

    setLoadingDate(true);
    packageRepository.searchDestinations(payload).then((res) => {
      const rawData = res?.data || [];
      const formattedDates = [];
      rawData.forEach((result) => {
        if (
          result?.goingDate &&
          result?.returnDateList &&
          result?.returnDateList.length > 0
        ) {
          const startParts = result?.goingDate.split("-");
          const startFormatted = new Date(
            parseInt(startParts[0]),
            parseInt(startParts[1]) - 1,
            parseInt(startParts[2])
          ).toLocaleDateString("pt-BR");

          result?.returnDateList.forEach((returnDate, index) => {
            const endParts = returnDate.split("-");
            const endFormatted = new Date(
              parseInt(endParts[0]),
              parseInt(endParts[1]) - 1,
              parseInt(endParts[2])
            ).toLocaleDateString("pt-BR");

            formattedDates.push({
              id: `${result.goingDate}_${returnDate}_${index}`,
              name: `${startFormatted} até ${endFormatted}`,
              start: result.goingDate,
              end: returnDate,
            });
          });
        }
      });

      setDateOptions(formattedDates);
      setLoadingDate(false);
    });
  };

  useEffect(() => {
    if (state !== initialState) {
      sessionStorage.setItem("packageSearch", JSON.stringify(state));
    }
  }, [state]);

  useEffect(() => {
    const packageSearch = getSessionStorage("packageSearch");
    if (packageSearch) setState(packageSearch);
  }, []);

  return (
    <S.Wrapper>
      <RegisterModal
        open={isOpenRegisterModal}
        onClose={handleRegisterModal}
        travelVoucherUser={user?.travelVoucher}
      />
      <ChoosePackageRooms
        open={openModalChild}
        onClose={() => setOpenModalChild(false)}
        onConfirm={(r) => mountRooms(r)}
        qtdChilds={state?.qtChild}
        initialAdults={state?.qtAdult}
        setQtChilds={(qt) => setState({ ...state, qtChild: qt })}
        handleChangeChildsAge={handleChangeChildsAge}
      />
      <Container>
        <div className="origem-destino-control">
          <Grid container spacing={3}>
            <Grid item xs={12} sm={6} md={3} lg={3}>
              <S.Title>Cidade ou aeroporto de origem</S.Title>
              <Autocomplete
                freeSolo
                disableClearable
                className={classes.root}
                noOptionsText={
                  loadingOrigin ? "Carregando..." : "Não encontrado"
                }
                options={options}
                getOptionLabel={(option) => (option ? `${option.name}` : "")}
                onInputChange={(event, value, reason) => {
                  if (reason === "input") {
                    handleAutoComplete(event, value);
                  }
                }}
                onChange={(event, newValue) => {
                  setState({
                    ...state,
                    origin: newValue,
                    destination: "",
                    dates: "",
                  });
                  setDestinationOptions([]);
                  setDateOptions([]);
                  if (newValue && newValue.id) {
                    setTimeout(() => {
                      handleDestination(newValue);
                    }, 300);
                  }
                }}
                filterOptions={(x) => x}
                value={state.origin !== "" ? state.origin : ""}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    placeholder="Origem"
                    variant="outlined"
                    fullWidth
                    className={classes.root}
                    error={send && state.origin === initialState.origin}
                    helperText={
                      send && state.origin === initialState.origin
                        ? "Origem não pode ser vazia"
                        : ""
                    }
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3} lg={3}>
              <S.Title>Destino</S.Title>
              <Autocomplete
                disableClearable
                className={classes.root}
                noOptionsText={
                  loadingDestination ? "Carregando..." : "Não encontrado"
                }
                filterOptions={(options, state) => {
                  if (!state.inputValue) return options;
                  return options.filter((option) =>
                    option.name
                      .toLowerCase()
                      .includes(state.inputValue.toLowerCase())
                  );
                }}
                options={destinationOptions}
                getOptionLabel={(option) => (option ? `${option.name}` : "")}
                onChange={(event, newValue) => {
                  setState({ ...state, destination: newValue, dates: "" });
                  setDateOptions([]);
                  if (newValue && newValue.id) {
                    setTimeout(() => {
                      handleDates(newValue);
                    }, 300);
                  }
                }}
                value={state.destination !== "" ? state.destination : null}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    placeholder="Destino"
                    variant="outlined"
                    fullWidth
                    className={classes.root}
                    error={
                      send && state.destination === initialState.destination
                    }
                    helperText={
                      send && state.destination === initialState.destination
                        ? "Destino não pode ser vazio"
                        : ""
                    }
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3} lg={2}>
              <S.Title>Data</S.Title>
              <Autocomplete
                disableClearable
                className={classes.root}
                noOptionsText={loadingDate ? "Carregando..." : "Não encontrado"}
                options={dateOptions}
                getOptionLabel={(option) => (option ? `${option.name}` : "")}
                onInputChange={(event, value, reason) => {
                  if (reason === "input") {
                    return;
                  }
                }}
                onChange={(event, newValue) => {
                  setState({ ...state, dates: newValue });
                }}
                filterOptions={(x) => x}
                value={state.dates !== "" ? state.dates : null}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    placeholder="Selecione uma data"
                    variant="outlined"
                    fullWidth
                    className={classes.root}
                    error={send && state.dates === initialState.dates}
                    helperText={
                      send && state.dates === initialState.dates
                        ? "Data não pode ser vazia"
                        : ""
                    }
                    onKeyDown={(event) => {
                      // Prevent typing by blocking keyboard input except navigation
                      if (
                        event.key !== "ArrowDown" &&
                        event.key !== "ArrowUp" &&
                        event.key !== "Enter" &&
                        event.key !== "Escape" &&
                        event.key !== "Tab"
                      ) {
                        event.preventDefault();
                      }
                    }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3} lg={2}>
              <S.Title>Quartos</S.Title>
              <TextField
                variant="outlined"
                fullWidth
                value={`${state.qtRooms} quarto${
                  state.qtRooms > 1 ? "s" : ""
                }, ${state.qtAdult + state.qtChild} hóspede${
                  state.qtAdult + state.qtChild > 1 ? "s" : ""
                }`}
                className={classes.root}
                onClick={() => setOpenModalChild(true)}
                error={send && state.qtAdult === initialState.qtAdult}
                helperText={
                  send && state.qtAdult === initialState.qtAdult
                    ? "Quartos não pode ser vazio"
                    : ""
                }
              />
            </Grid>
            <Grid
              item
              xs={12}
              sm={6}
              md={3}
              lg={2}
              style={{
                display: "flex",
                alignItems: "flex-end",
                marginTop: "14px",
              }}
            >
              <ThemeButton onClick={handleSubmit} className="submit1">
                Buscar
              </ThemeButton>
            </Grid>
          </Grid>
        </div>
      </Container>
    </S.Wrapper>
  );
};

export default PackageSearchInputs;
